import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { getActivitiesSettings } from 'helpers/objectiveSettings';
import RadioButton from 'components/atoms/form/RadioButton';

const ObjectivePickerWrapper = styled('div')`
    // border: 1px orange solid;
    padding-left: 5px;
    ${breakpoint('xs', 'sm')`
        // display: block;
        text-align: center;
        height: auto;
        align: top;
        margin-right: 0px;
        padding: 10px 0px;
    `}
    ${breakpoint('sm', 'md')`
        // justify-content: center;
        text-align: center;
        height: auto;
        align: top;
        margin-right: 0px;
        padding: 10px 0px;
    `}
`;

const IdRadio1 = 'objectiveSwitchingRadioButton1';
const IdRadio2 = 'objectiveSwitchingRadioButton2';

class ObjectiveSwitcher extends Component {
    state = {
        checkedEcpa: false,
        checkedCTR: false
    }

    render() {
        const {
            entityId,
            setObjectiveShadow,
            fetchEntityMeta,
            onClick: onClickOverride,
            objectiveLabelCode
        } = this.props;
        const { checkedEcpa, checkedCTR } = this.state;
        const touched = checkedCTR || checkedEcpa;
        const { pluralTerm: pluralObjectiveLabelCode } = getActivitiesSettings('ecpa', objectiveLabelCode);
        const onClick = onClickOverride || ((evt) => {
            const isEcpa = get(evt, 'target.id') === IdRadio1;
            if (isEcpa) {
                this.setState({
                    checkedEcpa: true,
                    checkedCTR: false
                });
            } else {
                this.setState({
                    checkedEcpa: false,
                    checkedCTR: true
                });
            }
            setObjectiveShadow(isEcpa ? 'ecpa' : 'ctr');
            fetchEntityMeta({ entityId, transactionId: 'update-objective-shadow' });
        });

        return (<ObjectivePickerWrapper>
            <RadioButton
                {...this.props}
                id={IdRadio1}
                input={{
                    onClick,
                    name: 'objectiveSwitchingRadioButton',
                    checked: touched ? checkedEcpa : this.props.objective === 'ecpa'
                }}
                label={pluralObjectiveLabelCode || 'eCPA'} />
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <RadioButton
                {...this.props}
                id={IdRadio2}
                input={{
                    onClick,
                    name: 'objectiveSwitchingRadioButton',
                    checked: touched ? checkedCTR : this.props.objective === 'ctr'
                }}
                label="CTR" />
        </ObjectivePickerWrapper>);
    }
}

ObjectiveSwitcher.propTypes = {
    entityId: PropTypes.number.isRequired,
    objective: PropTypes.oneOf(['ecpa', 'ctr']).isRequired,
    setObjectiveShadow: PropTypes.func.isRequired,
    fetchEntityMeta: PropTypes.func.isRequired,
    objectiveLabelCode: PropTypes.string
};

export default ObjectiveSwitcher;



// WEBPACK FOOTER //
// ./src/components/molecules/ObjectiveSwitcher.js